(function($) {
  'use strict';

  var initTiledGallery = function() {
    //init masonry component
    var $grid = $('.tiled-gallery__masonry-container').masonry({
      itemSelector:       '.tiled-gallery__masonry-item',
      columnWidth:        '.grid-sizer',
      percentPosition:    true,
      transitionDuration: 0,
      initLayout:         false
    });
    //add listener to show once loaded
    $grid.on('layoutComplete', function() {
      $('.tiled-gallery__masonry-container').css('opacity', 1);
    });

    $grid.masonry();

    //init slider component
    //get all tiled gallery components
    var sliders = $('.tiled-gallery__slider-container');
    //init each testimonial
    sliders.each(function() {
      var slider = $(this).slick({
        dots:           true,
        infinite:       false,
        dotsClass:      'slick-dots slick-dots--colored',
        arrows:         false,
        adaptiveHeight: true,
        mobileFirst:    true
      });
    });
  };

  $(window).on('load', function() {
    initTiledGallery();
  });
}(jQuery));
